import React, {useContext, useRef, useState} from "react";
import NIDGuide_image from "../../images/guide/FID_guide.png";
import Guid from "../Guid";
import Camera from "../Camera";
import Api from "../../tools/service";
import handleGenerateUuid from "../../tools/api/global/generateUuid";

import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";


import ProgressLoading from "../loading/ProgressLoading";
import ForeignerAuthenticationContext from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import {MdEditDocument} from "react-icons/md";
import {FaWpforms} from "react-icons/fa";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const CardReader = () => {
    const NidWebcam = useRef(null);
    const foreignerAuthAuthenticationContext = useContext(ForeignerAuthenticationContext);
    const [isLoading, setLoading] = useState(false)
    const NIDReaderGuidSlides = [
        {
            image: NIDGuide_image,
            title: "ونیفای",
            subTitle: "عکس مدرک مهاجرتی",
            texts: `در شرایط نوری مناسب و از فاصله نزدیک از مدرک مهاجرتی خود عکس بگیرید`
        }
    ];
    const [disabled,setDisabled]=useState(true)
    const [step,setStep]=useState(0)
    const onConfirm = (base64) => {
        setLoading(true);


        handleGenerateUuid("ForeignDocumentReader", foreignerAuthAuthenticationContext.token).then((uuid) => {

            Api.post(REQUEST_URLS.DIVAR_FOREIGNER_AUTH.FOREIGNER_DOCUMENT_READER, {
                uuid: uuid,
                pid: foreignerAuthAuthenticationContext.pid,
                doc_type:selectedDoc,
                Image: base64 ? base64.replace('data:image/jpeg;base64,', '') : base64.replace('data:image/jpeg;base64,', ''),

            }, {
                headers: {
                    "Authorization": `Bearer ${foreignerAuthAuthenticationContext.token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    foreignerAuthAuthenticationContext.handleGetProcess(foreignerAuthAuthenticationContext.pid)
                } else {
                    foreignerAuthAuthenticationContext.handleError({
                        status: status,
                        message: message,
                        data: data,
                        hasError: hasError,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',

                                onCancel: () => {
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                    setLoading(false);
                }

            })
                .catch((error) => {
                    setLoading(true);
                }).finally(res => {

            });

        }).catch((error) => {

        })
    }
    const [showGuide, setShowGuide] = useState(false);
    const [selectedDoc,setSelectedDoc]=useState(-1);
    const handleChangeSelect=(e)=>{

            if(e.target.value==-1){
                setDisabled(true);

                setSelectedDoc(e.target.value)
            }else {
                setDisabled(false);
                setSelectedDoc(e.target.value)
            }

    }
    if (isLoading) {
        return <ProgressLoading showProgress={false} type="NIDCardReader" duration={30} text="در حال دریافت اطلاعات "
                                theme="green"/>
    }
    return <div className="w-11/12 mt-5 md:w-5/12 mx-auto">
        {!showGuide&&step===0 && <div>
            <div className=" md:w-6/12 lg:w-6/12 mx-auto">

                <div className="w-full rounded-xl mt-5 bg-white p-5  flex flex-col pt-5 border-t ">
                    <div className="flex flex-col justify-center  mb-5 border-b pb-5  items-center">
                        <div className="w-16  flex justify-center items-center rounded-full text-sm h-16 bg-gray-200 ">
                            <FaWpforms className="text-2xl" />
                        </div>
                        <div className="mt-2 ">
                            <h1 className="text-center font-bold ">تکمیل اطلاعات</h1>
                            <p className="text-sm text-center ">لطفا نوع مدرک مهاجرتی را انتخاب کنید.</p>
                        </div>
                    </div>
                    <label className="text-sm" htmlFor="">مدرک مهاجرتی</label>
                    <select value={selectedDoc} onChange={handleChangeSelect} className="outline-none mt-2  focus:border-gray-100 bg-gray-100 text-sm  mt-3 rounded-lg bg-white p-2 " name="" id="">
                        <option value="-1">مدرک مهاجرتی را انتخاب کنید</option>
                        {foreignerAuthAuthenticationContext.process?.available_doc_types?.map(item=>{
                           return <option key={item.en} value={item.en}>{item.fa}</option>
                        })}
                    </select>
                    <Button disabled={disabled} className="text-sm rounded-lg mt-5 " theme="green" onClick={()=>{
                        setShowGuide(true)
                        setStep(1)
                    }}>مرحله بعد</Button>
                </div>
            </div>

        </div>}
        {showGuide&&step===1 && <Guid hasBack={true} onBack={()=>{setShowGuide(false);setStep(0)}} imageClass={'w-8/12 md:w-8/12 lg:w-3/12 xl:w-2/12'} closeGuid={() => {
            setShowGuide(false)
            setStep(1)
         }
        }
                            slides={NIDReaderGuidSlides}/>}

        {!showGuide&&step===1 && <Camera hasBack={true} onBack={()=>setStep(0)} webcamRef={NidWebcam} galleryEnable={false} handleShowGuid={() => {
            setShowGuide(true)
        }} title={'عکس مدرک مهاجرتی'} text={'در شرایط نوری مناسب از مدرک مهاجرتی خود عکس بگیرید'} faceMode="environment"
                               onCapture={onConfirm} isVideo={false} type="nid"/>}

    </div>
}
export default CardReader;